export const filteredListener =
  (callback: (type: string, data: any) => void) =>
  ({ data }: MessageEvent<any>) => {
    if (!data.type) {
      return;
    }
    callback(data.type, data);
  };
